import React, { PureComponent, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './HoverPopup.module.scss';

export interface IHoverPopupProps {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  block?: boolean;
  style?: { [key: string]: string };
}

class HoverPopup extends PureComponent<IHoverPopupProps> {
  setIsHover = (isHover: boolean): void => {
    this.setState({ isHover });
  };

  state = {
    isHover: false,
    setIsHover: this.setIsHover,
  };

  render(): ReactNode {
    const { children, className, disabled, block, style } = this.props;
    const { isHover } = this.state;
    const classes = classNames(styles['ta-hover-popup'], className, {
      [styles['is-hover']]: isHover,
      [styles.disabled]: disabled,
      [styles.block]: block,
    });

    return (
      <HoverPopupContext.Provider value={this.state}>
        <div className={classes} style={style} data-testid='hover-popup'>
          {children}
        </div>
      </HoverPopupContext.Provider>
    );
  }
}

export const HoverPopupContext = React.createContext({
  isHover: false,
  setIsHover: (isHover: boolean) => {},
});

export default HoverPopup;
